import SelectedCustomer from '@/platform/common/components/SelectedCustomer/SelectedCustomer';
import { useFilters } from '@/platform/hooks/useFilters';
import {
    Button,
    Container,
    FilterBar,
    FilterBarDropdown,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
} from '@/platform/ui';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { router, usePage } from '@inertiajs/react';
import { useState } from 'react';
import ReportPie from './components/ReportPie';
import ReportTable from './components/ReportTable';

const ONLY = ['disability_expenses'];

const TABS = [
    { key: 'lkv', label: 'Loonkostenvoordeel' },
    { key: 'whk', label: 'Whk controle' },
];

const ALL_ENTITIES = { id: 'all', name: 'Alle entiteiten' };
const TOTAL_YEAR = { id: 'total', name: 'Totaal' };

const IndexView = () => {
    const { auth, disability_expenses, years } = usePage().props;
    const { filters, updateFilters } = useFilters(ONLY);
    const [tab, setTab] = useState(
        () => new URLSearchParams(window.location.search).get('tab') || 'lkv'
    );
    const [isRefreshing, setIsRefreshing] = useState(false);

    const entityOptions = [
        ALL_ENTITIES,
        ...(auth?.customer?.entities || []).map(entity => ({
            id: entity.id,
            name: entity.number
                ? `${entity.number}. ${entity.name}`
                : entity.name,
        })),
    ];

    const yearOptions = [
        ...(years || []).map(year => ({ id: year, name: String(year) })),
        TOTAL_YEAR,
    ];

    const selectedEntity = entityOptions.find(
        option => String(option.id) === String(filters?.entity_id)
    );
    const selectedYear = yearOptions.find(
        option => String(option.id) === String(filters?.year)
    );

    const refresh = () =>
        router.post(
            `/customers/${auth.customer.id}/statistics/refresh`,
            filters,
            {
                preserveScroll: true,
                preserveState: true,
                onStart: () => setIsRefreshing(true),
                onFinish: () => setIsRefreshing(false),
            }
        );

    return (
        <Container>
            <SelectedCustomer />

            <TabNav label='Statistieken' className='mb-4'>
                {TABS.map(item => (
                    <TabNavItem
                        key={item.key}
                        active={tab === item.key}
                        onClick={() => setTab(item.key)}
                    >
                        {item.label}
                    </TabNavItem>
                ))}
            </TabNav>

            {tab === 'whk' && (
                <Segment>
                    <SegmentHeader header='AO-lasten'>
                        <Button
                            onClick={refresh}
                            loading={isRefreshing}
                            aria-label='Rapport vernieuwen'
                        >
                            {!isRefreshing && (
                                <ArrowPathIcon className='size-5' />
                            )}
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FilterBar>
                            <FilterBarDropdown
                                label={
                                    selectedEntity?.name || ALL_ENTITIES.name
                                }
                                options={entityOptions}
                                value={filters?.entity_id}
                                onChange={value =>
                                    updateFilters('entity_id', value)
                                }
                            />
                            <FilterBarDropdown
                                label={selectedYear?.name || TOTAL_YEAR.name}
                                options={yearOptions}
                                value={filters?.year}
                                onChange={value => updateFilters('year', value)}
                            />
                        </FilterBar>

                        <div className='grid grid-cols-1 items-start gap-6 lg:grid-cols-5'>
                            <div className='lg:col-span-3'>
                                <ReportTable
                                    title='AO-lasten'
                                    rows={disability_expenses?.totals}
                                />
                            </div>
                            <div className='mx-auto w-full max-w-[350px] lg:col-span-2'>
                                <ReportPie rows={disability_expenses?.totals} />
                            </div>
                        </div>
                    </SegmentContent>
                </Segment>
            )}
        </Container>
    );
};

export default IndexView;
